import IResetPassword from "../models/account/IResetPassword";
import { IUserListResponse } from "../models/account/IUserInfo";
import IUserProfile, {
    IUpdateUserProfile
} from "../models/account/IUserProfile";
import { apiSlice } from "./apiSlice";

const ROUTE = "/account";

const accountApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserList: builder.query<IUserListResponse, void>({
            query: () => `${ROUTE}/get-user-list`
        }),
        getMyProfile: builder.query<IUserProfile, void>({
            query: () => "/me/profile"
        }),
        resetPasswordTokenCheck: builder.query<boolean, string>({
            query: (token) => `${ROUTE}/reset-password-token-check/${token}`
        }),
        resetPassword: builder.mutation<string, IResetPassword>({
            query: (resetPassword) => ({
                url: `${ROUTE}/reset-password`,
                method: "POST",
                body: resetPassword,
                responseHandler: (response) => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        return response.json();
                    }
                }
            })
        }),
        updateUserProfile: builder.mutation<IUserProfile, IUpdateUserProfile>({
            query: (body) => ({
                url: `${ROUTE}/update-profile`,
                method: "PUT",
                body
            })
        }),
        resetTermsAcceptance: builder.mutation<void, void>({
            query: () => ({
                url: `${ROUTE}/reset-terms-acceptance`,
                method: "POST"
            })
        }),
        getRefreshStatus: builder.query<{ shouldRefresh: boolean }, void>({
            query: () => `${ROUTE}/me/refresh-status`
        })
    })
});

export const {
    useGetMyProfileQuery,
    useGetRefreshStatusQuery,
    useGetUserListQuery,
    useResetPasswordMutation,
    useResetPasswordTokenCheckQuery,
    useResetTermsAcceptanceMutation,
    useUpdateUserProfileMutation
} = accountApiSlice;
